import React, { useState } from "react";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import "./navigation.css";

const Navigation = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  
  const canGoBack = location.pathname !== "/";
  
  const handleBack = () => {
    navigate(-1);
  };

  const handleLinkClick = () => {
    setSidebarOpen(false);
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <>
      <nav className="nav">
        <div className="nav__container">
          <div className="nav__left">
            <Link to="/" className="nav__brand" onClick={handleLinkClick}>
              <span className="nav__brand-icon">✨</span>
              <span className="nav__brand-text">Гігея</span>
            </Link>
          </div>
          
          {/* Desktop Navigation */}
          <div className="nav__links nav__links--desktop">
            <NavLink to="/" className={({ isActive }) => `nav__link ${isActive ? "active" : ""}`} end>
              Домівка
            </NavLink>
            <NavLink to="/client-list" className={({ isActive }) => `nav__link ${isActive ? "active" : ""}`}>
              Клієнти
            </NavLink>
            <NavLink to="/service-list" className={({ isActive }) => `nav__link ${isActive ? "active" : ""}`}>
              Послуги
            </NavLink>
            <NavLink to="/product-list" className={({ isActive }) => `nav__link ${isActive ? "active" : ""}`}>
              Склад
            </NavLink>
            <NavLink to="/reports" className={({ isActive }) => `nav__link ${isActive ? "active" : ""}`}>
              Звіти
            </NavLink>
          </div>

          {/* Mobile Controls */}
          <div className="nav__mobile-controls">
            <Link to="/" className="nav__mobile-btn nav__mobile-btn--home" onClick={handleLinkClick}>
              <span className="nav__mobile-btn-icon">🏠</span>
            </Link>
            {canGoBack && (
              <button className="nav__mobile-btn nav__mobile-btn--back" onClick={handleBack}>
                <span className="nav__mobile-btn-icon">←</span>
              </button>
            )}
            <button className="nav__mobile-btn nav__mobile-btn--menu" onClick={toggleSidebar}>
              <span className="nav__mobile-btn-icon">☰</span>
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Sidebar Overlay */}
      <div className={`nav__sidebar-overlay ${sidebarOpen ? "nav__sidebar-overlay--visible" : ""}`} onClick={() => setSidebarOpen(false)}></div>

      {/* Mobile Sidebar */}
      <div className={`nav__sidebar ${sidebarOpen ? "nav__sidebar--open" : ""}`}>
        <div className="nav__sidebar-header">
          <span className="nav__sidebar-brand">
            <span className="nav__sidebar-brand-icon">✨</span>
            <span className="nav__sidebar-brand-text">Гігея</span>
          </span>
          <button className="nav__sidebar-close" onClick={() => setSidebarOpen(false)}>
            ×
          </button>
        </div>
        <div className="nav__sidebar-links">
          <NavLink to="/" className={({ isActive }) => `nav__sidebar-link ${isActive ? "active" : ""}`} end onClick={handleLinkClick}>
            Домівка
          </NavLink>
          <NavLink to="/client-list" className={({ isActive }) => `nav__sidebar-link ${isActive ? "active" : ""}`} onClick={handleLinkClick}>
            Клієнти
          </NavLink>
          <NavLink to="/service-list" className={({ isActive }) => `nav__sidebar-link ${isActive ? "active" : ""}`} onClick={handleLinkClick}>
            Послуги
          </NavLink>
          <NavLink to="/product-list" className={({ isActive }) => `nav__sidebar-link ${isActive ? "active" : ""}`} onClick={handleLinkClick}>
            Склад
          </NavLink>
          <NavLink to="/reports" className={({ isActive }) => `nav__sidebar-link ${isActive ? "active" : ""}`} onClick={handleLinkClick}>
            Звіти
          </NavLink>
        </div>
      </div>
    </>
  );
};

export default Navigation;
